import React, { type CSSProperties, type ReactNode } from 'react';
import './Grid.css';

type GridStyle = CSSProperties & {
  '--merlin-grid-gutter'?: string;
  '--merlin-grid-xs-width'?: string;
  '--merlin-grid-md-width'?: string;
};

interface RowProps {
  gutter?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

interface ColProps {
  span?: number;
  xs?: number;
  md?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

function spanToWidth(span: number): string {
  return `${(Math.min(Math.max(span, 1), 12) / 12) * 100}%`;
}

export function Row({ gutter = 0, className, style, children }: RowProps) {
  const rowStyle: GridStyle = {
    ...style,
    '--merlin-grid-gutter': `${gutter}px`,
  };

  return (
    <div className={['merlin-grid-row', className].filter(Boolean).join(' ')} style={rowStyle}>
      {children}
    </div>
  );
}

export function Col({ span, xs, md, className, style, children }: ColProps) {
  const colStyle: GridStyle = {
    ...style,
    '--merlin-grid-xs-width': spanToWidth(xs ?? span ?? 12),
    '--merlin-grid-md-width': md != null ? spanToWidth(md) : undefined,
  };

  return (
    <div className={['merlin-grid-col', className].filter(Boolean).join(' ')} style={colStyle}>
      {children}
    </div>
  );
}
